<template>
  <div>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a Product Type
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-select
                v-model="form.parent_id"
                :items="parentTypes"
                item-text="name"
                item-value="id"
                outlined
                label="Parent Category (optional)"
                prepend-inner-icon="mdi-folder-outline"
                clearable
                hint="Set this to show inside a parent category"
                persistent-hint
              ></v-select>
            </v-col>

            <v-col sm="4">
              <v-select
                v-model="form.app_route"
                :items="appRouteOptions"
                item-text="label"
                item-value="value"
                outlined
                label="App Route"
                prepend-inner-icon="mdi-routes"
                hint="Where does tapping this category go in the app?"
                persistent-hint
              ></v-select>
            </v-col>

            <v-col sm="4">
              <v-file-input
                label="File input"
                outlined
                type="file"
                v-model="form.image_path"
                placeholder="Upload the image here"
              ></v-file-input>
            </v-col>
          </v-row>

          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save product Type
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ProductTypeCreatePage",
  data() {
    return {
      form: {
        name: "",
        parent_id: null,
        app_route: "invoicing",
        image_path: null,
      },
      product_type: null,
      parentTypes: [],
      appRouteOptions: [
        { label: "Invoicing (Default)", value: "invoicing" },
        { label: "RMC Plant Listing", value: "rmc_plant" },
        { label: "RMC Plans", value: "rmc_plans" },
      ],
    };
  },

  mounted() {
    axios.get("/product_types").then((r) => {
      this.parentTypes = (r.data.data || []).filter((t) => !t.parent_id);
    });
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        let response = await axios.post("/product_types", this.form);
        this.product_type = response.data.data;
        await this.handleFileUpload();
        this.isLoading = false;
        await this.saveUserTimestamp(null, this.form);
        this.$router.push("/product-types");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      let formData = new FormData();
      this.file_attachment = this.form.image_path;
      formData.append("id", this.product_type.id);
      formData.append("image_path", this.file_attachment);
      await axios
        .post("product_types/upload_image_path", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
      this.isUploading = false;
    },
  },
};
</script>
